import { createCssCompNode } from '../cssCompNode'
import { hasResponsiveLayout } from '../../utils/componentCssUtils'
import { Component } from '@wix/thunderbolt-becky-types'
import { FeatureRefs } from '../cssFeatures.types'
import { ModeRef } from '@wix/thunderbolt-catharsis'

export const rotatedComponentsStyleCss = createCssCompNode('rotatedComponentsStyle', 'rotatedComponentsStyleCss', {
	getDependencies: (component: Component, compNodeRefs: FeatureRefs<'rotatedComponentsStyle'>) => {
		if (component.modes?.overrides) {
			return component.modes.overrides.reduce<Record<string, ModeRef>>((acc, override) => {
				if (override.layout?.rotationInDegrees && override.modeIds) {
					override.modeIds.forEach((x) => (acc[x] = compNodeRefs.modes(x)))
				}
				return acc
			}, {})
		}
		return null
	},
	toViewItem: (component, deps) => {
		if (deps && component.modes?.overrides) {
			return component.modes.overrides.reduce<Record<string, number>>((acc, override) => {
				if (override.layout?.rotationInDegrees && override.modeIds) {
					const { layout, modeIds } = override
					modeIds.forEach((modeId) => {
						const modePrefixSelector = deps[modeId].prefix // '' | [data-mode=hover]
						acc[modePrefixSelector] = layout.rotationInDegrees
					})
				}
				return acc
			}, {})
		}

		return !hasResponsiveLayout(component) && component.layout.rotationInDegrees
			? { '': component.layout.rotationInDegrees }
			: null
	},
})
